import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=2068e16b&scoped=true&"
import script from "./Publication.js?vue&type=script&lang=js&"
export * from "./Publication.js?vue&type=script&lang=js&"
import style0 from "./Publication.scss?vue&type=style&index=0&id=2068e16b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068e16b",
  null
  
)

export default component.exports